<template>
  <div class="flex justify-end mb-2">
    <div class="flex items-center">
      <div class="relative inline-block mr-2">
        <Select :options="voiceOptions" v-model:voice="selectedVoice" />
      </div>
    </div>
    <button class="primary-btn" v-if="!isPlaying" @click="speakAnswer">
      <PlayIcon class="w-6 h-6 mr-2" /> AI 朗读
    </button>
    <button class="secondary-btn" v-else @click="stopSpeakAnswer">
      <StopIcon class="w-6 h-6 mr-2" /> 停止朗读
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useTTS } from "@/hooks/useTTS";
const { handlePlay, isPlaying, stopPlayback } = useTTS();
import { PlayIcon, StopIcon } from "@heroicons/vue/24/outline";
import Select from "@/components/ui/Select.vue";
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
});

const voiceOptions = ref([
  { id: 0, value: "bm_lewis", text: "🇬🇧英音男声" },
  { id: 1, value: "bf_emma", text: "🇬🇧英音女声" },
  { id: 2, value: "am_echo", text: "🇺🇸美音男声" },
  { id: 3, value: "af_heart", text: "🇺🇸美音女声" },
]);
const selectedVoice = ref("bm_lewis");

const speakAnswer = () => {
  handlePlay(props.text, "kokoro", selectedVoice.value, 1);
};

const stopSpeakAnswer = () => {
  stopPlayback();
};
</script>
